export const page = {
    data() {
        return {
            total: 0,
            pageNo: 1,
            pageSize: 25,
            pageSizeList: [10, 25, 50, 100]
        }
    },
    methods: {
        numberChange(pageNo, Function) {
            this.pageNo = pageNo;
            if (Function) Function();
        },
        sizeChange(pageSize, Function) {
            this.pageNo = 1;
            this.pageSize = pageSize;
            if (Function) Function();
        }
    }
}
export const table = {
    data() {
        return {
            tableData: [],
            tableLoading: false,
            loadingText: "加载中",
            loadingIcon: "el-icon-loading"
        }
    },
    methods: {
        openLoading() {
            this.tableLoading = true;
        },
        closeLoading() {
            this.tableLoading = false;
        }
    }
}
export const message = {
    data() {
        return {}
    },
    methods: {
        openSuccess(message) {
            this.$message({
                type: 'success',
                message
            })
        },
        openWarn(message) {
            this.$message({
                type: 'warning',
                message
            })
        },
        openError(message) {
            this.$message({
                type: 'error',
                message
            })
        }
    }
}
export const btn = {
    data() {
        return {
            btnLoading: false
        }
    },
    methods: {
        openBtn() {
            this.btnLoading = true;
        },
        closeBtn() {
            this.btnLoading = false;
        }
    }
}
export const dialog = {
    data() {
        return {
            title: "",
            centerDialogVisible: false,
            deleteModal: false
        }
    },
    methods: {
        openDialog(title) {
            this.title = title;
            this.centerDialogVisible = true;
        },
        closeDialog() {
            this.centerDialogVisible = false;

        },
        openDeleteDialog() {
            this.deleteModal = true;
        },
        closeDeleteDialog() {
            this.deleteModal = false;
        }
    }
}
// 打印表格，数据格式处理
export const formatPrintTableData = {
    data() {
        return {
            printTableData: [],
        }
    },
    methods: {
        // 表格为原生table,需将表头key与列表对应值顺序搁置在同一位置，例如 columns:[{key:'a'},{key:'b'}],data:[{a:1,b:2},{a:3,b:4}]
        getPrintData(data, size = null) {
            this.printTableData = [];
            var keys = this.printColumns.map(item => {
                return item.key;
            });
            data.filter((item, index) => {
                let arr = [];
                for (let temp in item) {
                    if (keys.indexOf(temp) >= 0) {
                        arr[keys.indexOf(temp)] = item[temp];
                    }
                }
                arr[0] = index + 1;
                let obj = {};
                keys.filter((m, index) => {
                    obj[m] = arr[index];
                });
                this.printTableData.push(obj);
            });
            this.prints(size);
        },
        // 调用浏览器的打印功能，由于局部打印，故创建iframe标签
        prints(size) {
            this.$nextTick(() => {
                let count = 0;
                let tableCount = 0;

                let pageH =
                    (document.querySelector("#printcontent").clientWidth / 595.28) * 841.89;
                let unit = document.querySelectorAll(".unit");

                unit.forEach((item, index) => {
                    let beforeH = item.offsetTop;
                    let afterH = beforeH + item.clientHeight;
                    let currentPage = parseInt(beforeH / pageH);
                    if (currentPage !== parseInt(afterH / pageH)) {
                    //   that.$set(
                    //     that.printPage,
                    //     "tableData" + tableCount,
                    //     that.tableData.slice(count, index)
                    //   );
                    
                      count = index;
                      tableCount++;
                    }
                  });
                var el = this.$refs.print_table.$vnode.child.$el,
                    iframe = document.createElement("IFRAME"),
                    doc = null;
                iframe.setAttribute("id", "print-iframe");
                iframe.setAttribute(
                    "style",
                    "width:100%;font-size:20px;text-align:center"
                );
                document.body.appendChild(iframe);
                doc = iframe.contentWindow.document;
                if (size) {
                    doc.write(
                        '<html><head><style type="text/css" media="all">@page {size: landscape; margin: 0mm 8mm;} .print_table {page-break-after:always;table-layout: fixed;width: 100%;margin:30px 0 0 0}.print_table th {min-width: 0;height: 48px;box-sizing: border-box;border-bottom: 1px solid #e9eaec;border-right: 1px solid #e9eaec;text-overflow: ellipsis;vertical-align: middle;white-space: nowrap;overflow: hidden;}.print_table tbody td {border: 1px solid #e9eaec;border-top: none;border-left: none;min-width: 0;height: 48px;box-sizing: border-box;text-overflow: ellipsis;vertical-align: middle;}</style></head><body style="zoom: 80%;">' +
                        el.innerHTML +
                        "</body></html>"
                    );
                } else {
                    doc.write(
                        '<html><head><style type="text/css" media="all">@page {size: auto; margin: 0mm 5mm;} .print_table {page-break-after:always;table-layout: fixed;width: 100%;margin:30px 0 0 0}.print_table th {min-width: 0;height: 48px;box-sizing: border-box;border-bottom: 1px solid #e9eaec;border-right: 1px solid #e9eaec;text-overflow: ellipsis;vertical-align: middle;white-space: nowrap;overflow: hidden;}.print_table tbody td {border: 1px solid #e9eaec;border-top: none;border-left: none;min-width: 0;height: 48px;box-sizing: border-box;text-overflow: ellipsis;vertical-align: middle;}</style></head><body style="zoom: 80%;">' +
                        el.innerHTML +
                        "</body></html>"
                    );
                }
                doc.close();
                iframe.contentWindow.focus();
                iframe.contentWindow.print();
                document.body.removeChild(iframe);
            });
        }
    }
}
// 获取年份
export const selectiveYear = {
    data() {
        return {
            yearLists: []
        }
    },
    methods: {
        getYearLists(query = null,Function = null,number = 4) {
            let myDate = new Date();
            let tYear = myDate.getFullYear();
            let i = 1;
            if(query) query.year = tYear;
            while (i <= number) {
                this.yearLists.push({
                    value: tYear,
                    label: tYear + "年"
                })
                tYear--
                i++
            }
            if(Function) Function();
        }
    }
}